import React from 'react';
import Text from '@/components/Text';
import { SlideProps } from './slideTypes';
import { SLIDE_COMPONENT_TEXT_SIZE } from './slideConstants';

export function TimelineSlide({ slide }: SlideProps) {
  const rows = Array.isArray(slide.data?.rows) 
    ? slide.data.rows.filter((row: any) => row != null) 
    : [];

  return (
    <div className="flex flex-col gap-3 md:gap-4 w-full px-4 md:px-6 py-6 md:py-8 items-start justify-center overflow-y-auto max-h-full">
      <div className="relative border-l-2 border-white/10 ml-2 md:ml-4 space-y-4 md:space-y-6 w-full text-left">
        {rows.map((row: any[], idx: number) => {
          const [date, narrative] = Array.isArray(row) ? row : [undefined, undefined];
          return (
            <div key={idx} className="relative pl-4 md:pl-6 text-left">
              <div className="absolute -left-[9px] top-1.5 w-4 h-4 rounded-full bg-white border-2 border-blue-600 shadow-sm" />
              <div className="flex flex-col gap-1 text-left">
                <Text size="xs" className="text-blue-400 font-normal uppercase tracking-widest text-left md:text-sm">
                  {date || `Event ${idx + 1}`}
                </Text>
                <Text size={SLIDE_COMPONENT_TEXT_SIZE} className="text-white/90 leading-relaxed text-left text-xs md:text-md">
                  {narrative || 'Details unavailable.'}
                </Text>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
